import { useIntl } from '@nobia/zeus-components/lib/i18n'
import { useCallback } from 'react'

export const useTranslation = prefix => {
  const intl = useIntl()
  const enGbIntl = new Intl.DateTimeFormat('en-GB')

  const t = useCallback(
    (key, variables, skipPrefix) =>
      intl.formatMessage(
        { id: !skipPrefix && prefix ? `${prefix}.${key}` : key },
        variables
      ),
    [prefix, intl]
  )
  const country = {
    code: t('app.country.code'),
    currency: t('app.country.currency'),
  }

  return { t, intl, enGbIntl, country }
}
